import Analytics from 'components/images/analytics-snapshot.jpg';
import Metric from 'components/images/metric-diagram.png';
import * as React from 'react';
export default {
  Analytics,
  Metric,
  React
};